import api from '../../plugins/api';

const getClientsNavigationCount = (params) => {
  return api.get('/api/crm/clients/getClientsNavigationCount', params);
};

export default getClientsNavigationCount;
